// extracted by mini-css-extract-plugin
export default {"DeleteHealthChecksDialog":"DeleteHealthChecksDialog_DeleteHealthChecksDialog__ZK2Xh"};